<template>
  <div class="call-me-mile">
    <div class="hotline">
      售前咨询热线：<span class="hotline-number"><a :href="'tel:' + '400-608-3777'">400-608-3777</a></span>
    </div>
    <div class="company-info">
      <div class="logo-name">
        <img src="@/assets/home/logoCallMe.png" alt="logo" class="logo" />

      </div>
      <div class="info-list">
        <div class="info-item">
          官方邮箱：<span class="info-value">hrkj@chnsoft.com.cn</span>
        </div>
        <div class="info-item">
          <span style="    white-space: nowrap;">公司地址：</span><span class="info-value" style="    white-space: nowrap;">中国（上海）自由贸易试验区川桥路701弄3号103室</span>
        </div>
        <div class="info-item wechat" style="cursor:pointer;opacity: 1;">
          <!-- <span class="wechat-icon"></span> -->
          <img src="@/assets/home/微信1x.png" alt="微信" class="wechat_icon" @click="showWechat = true" />
          <span style="opacity: 1;cursor:pointer;"  @click="showWechat = true" >微信公众号</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <div>华软科技股份有限公司版权所有</div>
      <div><a href="https://beian.miit.gov.cn/#/Integrated/index">沪ICP备2025148463号</a></div>
    </div>
    <div v-if="showWechat" class="wechat-modal" @click.self="showWechat = false">
      <div class="wechat-modal-content">
        <img src="../../assets/home/wxCode.jpg" alt="微信公众号二维码" class="wechat-qrcode" />
        <div class="wechat-modal-desc">长按或截图扫码关注华软科技股份有限公司公众号</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CallMeMile',
  data() {
    return {
      showWechat: false
    }
  }
}
</script>

<style  lang="scss" scoped>
.call-me-mile {
  background: #232a32;
  color: #fff;
  padding: 16PX 0 0 0;
  font-family: "Microsoft YaHei", Arial, sans-serif;
  text-align: center;
  min-height: 320PX;
}

.hotline {
  border: 1PX solid #3c434a;
  border-radius: 8PX;
  display: inline-block;
  font-size: 14PX;
  margin-bottom: 32PX;
  letter-spacing: 2PX;
  height: 44PX;
  line-height: 44PX;
  width: calc(100% - 32PX);
  margin: 0PX 16PX;
}

.hotline-number {
  font-weight: bold;
  font-size: 14PX;
  margin-left: 8PX;
}

.company-info {
  margin: 20PX 16PX 0;
  text-align: left;
}

.logo-name {
  display: flex;
  align-items: center;
  justify-content: left;
  margin-bottom: 18PX;
}

.logo {
  height: 25PX;
  margin-right: 12PX;
}

.company-name {
  font-size: 24PX;
  font-weight: bold;
  letter-spacing: 2PX;
}

.info-list {
  max-width: 420PX;
}

.info-item {
  font-size: 12PX;
  margin: 8PX 0;
  color: #fff;
  opacity: 0.6;
  display: flex;
  align-items: center;
  justify-content: left;
}

.info-value {
  color: #fff;
  margin-left: 4PX;
}

.wechat {
  margin-top: 10PX;
  transition: opacity 0.2s;

  .wechat_icon {
    margin-right: 5PX;
    /* 统一使用小写 px，并增加限制，鸿蒙设备上强制生效 */
    width: 20px !important;
    height: 20px !important;
    max-width: 20px !important;
    max-height: 20px !important;
    object-fit: contain;
    display: inline-block;
  }
}

.wechat:hover {
  opacity: 0.8;
}

.wechat-modal {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);

  display: flex;
  justify-content: center;
  align-items: center;
}

.wechat-modal-content {
  background: #fff;
  border-radius: 10PX;
  padding: 8PX;
  text-align: center;
  width: 180px;
  box-shadow: 0 4PX 24PX rgba(0, 0, 0, 0.18);
  position: relative;
}

.wechat-qrcode {
  width: 100%;
  object-fit: contain;
}

.wechat-modal-desc {
  width: 100%;
  position: absolute;
  bottom: -43PX;
  font-family: PingFang SC;
  font-size: 13PX;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0px;
  font-variation-settings: "opsz" auto;
  color: #FFFFFF;
}

.footer {
  border-top: 1PX solid #3c434a;
  margin: 18PX 16px 0;
  padding: 18PX 0 8PX 0;
  font-size: 10PX;
  color: #FFFFFF;
  opacity: 0.6;
  line-height: 1.8;
  display: flex;
  justify-content: center;
  gap: 16PX;
}
</style>
